class AwProductCard extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  onClick = (event) => {
    const swatch = event.target.closest('[data-aw-variant-image]');
    if (!swatch || !this.contains(swatch)) return;

    event.preventDefault();
    event.stopPropagation();
    this.selectSwatch(swatch);
  };

  onKeydown = (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const swatch = event.target.closest('[data-aw-variant-image]');
    if (!swatch || !this.contains(swatch)) return;

    const swatches = [...this.querySelectorAll('[data-aw-variant-image]')];
    const currentIndex = swatches.indexOf(swatch);
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const next = swatches[(currentIndex + direction + swatches.length) % swatches.length];
    event.preventDefault();
    next.focus();
    this.selectSwatch(next);
  };

  selectSwatch(swatch) {
    const imageUrl = swatch.dataset.awVariantImage;
    const imageAlt = swatch.dataset.awVariantAlt;
    const primaryImage = this.querySelector('.card__media .media > img:first-child');

    if (primaryImage && imageUrl) {
      primaryImage.removeAttribute('srcset');
      primaryImage.removeAttribute('sizes');
      primaryImage.src = imageUrl;
      if (imageAlt) primaryImage.alt = imageAlt;
    }

    this.querySelectorAll('[data-aw-variant-image]').forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }
}

if (!customElements.get('aw-product-card')) customElements.define('aw-product-card', AwProductCard);
